export const BOOK_PAGE_INDEX = "BOOK_PAGE_INDEX";
export const BOOK_NEXT_PAGE = "BOOK_NEXT_PAGE";
export const BOOK_PREV_PAGE = "BOOK_PREV_PAGE";
export const BOOK_FIRST_PAGE = "BOOK_FIRST_PAGE";
export const BOOK_LAST_PAGE = "BOOK_LAST_PAGE";
export const BOOK_SINGLE_PAGE_LAYOUT = 'BOOK_SINGLE_PAGE_LAYOUT';
export const BOOK_DOUBLE_PAGE_LAYOUT = 'BOOK_DOUBLE_PAGE_LAYOUT';
